import { render, staticRenderFns } from "./OrderModal.vue?vue&type=template&id=1dbd9715&scoped=true"
import script from "./OrderModal.vue?vue&type=script&lang=ts"
export * from "./OrderModal.vue?vue&type=script&lang=ts"
import style0 from "./OrderModal.vue?vue&type=style&index=0&id=1dbd9715&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbd9715",
  null
  
)

export default component.exports